import { makeStyles } from "@mui/styles";

export default makeStyles(() => ({
  link: {
    textDecoration: "none",
    color: "inherit",
  },
}));
